<template>
  <a-card class="style1">
    <h3 class="pb-2">Shared Story</h3>
    <a-table :loading="isLoading" :columns="columns" :data-source="videoData" size="middle" bordered rowKey="id">
      <div slot="slug" slot-scope="text, record">
        <a :href="getVideoUrl(record)" target="_blank" rel="noopener noreferrer">
          {{ record.slug }}
        </a>
      </div>
      <div slot="email" slot-scope="text, record">{{ getEmail(record) }}</div>
      <div slot="fullname" slot-scope="text, record">{{ getFullName(record) }}</div>
      <div slot="role" slot-scope="text, record">{{ getRole(record) }}</div>
      <div slot="email_moderator" slot-scope="text, record">{{ getModeratorEmail(record) }}</div>
      <div slot="fullname_moderator" slot-scope="text, record">
        {{ getModeratorFullName(record) }}
      </div>
      <div slot="reason" slot-scope="text">
        <a @click="e => showReasonInfo(text)">{{ text }}</a>
      </div>
      <div slot="created_at" slot-scope="text, record">
        {{ getCreatedAt(record) }}
      </div>
      <div slot="signature" slot-scope="text, record">
        <a :href="record.signature" download="signature.png">
          <a-icon type="download" />
        </a>
      </div>
      <div slot="status" slot-scope="text, record">
        <a-select :default-value="text || 'review'" :showArrow="false" @change="e => handleStatusChange(e, record)" style="min-width: 120px;" :class="`select-value-${text}`">
          <a-select-option v-for="(ms, index) in videoStatus" :value="ms.value" :key="index" :class="`select-option-${ms.value}`">
            {{ ms.text }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="action" slot-scope="record" class="action">
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
    <a-modal v-model="reasonModalVisible" title="Block Reason" on-ok="handleReasonOk">
      <template slot="footer">
        <a-button key="ok" type="primary" @click="handleReasonOk">
          Ok
        </a-button>
      </template>
      <p>{{ reason }}</p>
    </a-modal>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import store from '@/store';
import { includes, replace, map } from 'lodash';
import moment from 'moment';
import AdminService from '@/services/AdminService';
import Constants from '@/constants.js';
export default {
  data() {
    const roleInfo = [
      { text: 'Admin', value: 'admin' },
      { text: 'Care', value: 'care' },
      { text: 'Disciple', value: 'disciple' },
      { text: 'Evangelism', value: 'evangelism' },
      { text: 'Individual', value: 'individual' },
    ];

    const videoStatus = [
      { text: 'Under review', value: 'review' },
      { text: 'Approved', value: 'approved' },
      { text: 'Not Sure', value: 'notsure' },
      { text: 'Blocked', value: 'blocked' },
    ];
    return {
      form: this.$form.createForm(this),
      videos: [],
      searching: '',
      error: '',
      isLoading: true,
      videoData: [],
      reasonModalVisible: false,
      reason: '',
      videoStatus,
      roleInfo: map(roleInfo, item => ({ label: item.text, value: item.value })),
      columns: [
        {
          title: 'Slug',
          dataIndex: 'slug',
          key: 'slug',
          scopedSlots: {
            customRender: 'slug',
          },
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          scopedSlots: {
            customRender: 'email',
          },
        },
        {
          title: 'Full Name',
          dataIndex: 'fullname',
          key: 'fullname',
          scopedSlots: {
            customRender: 'fullname',
          },
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          scopedSlots: {
            customRender: 'role',
          },
          filters: roleInfo,
          onFilter: (value, record) => includes(record.user.role, value),
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          filters: videoStatus,
          onFilter: (value, record) => includes(record.status, value),
        },
        {
          title: 'Email(Moderator)',
          dataIndex: 'email_moderator',
          key: 'email_moderator',
          scopedSlots: {
            customRender: 'email_moderator',
          },
        },
        {
          title: 'Full Name(Moderator)',
          dataIndex: 'fullname_moderator',
          key: 'fullname_moderator',
          scopedSlots: {
            customRender: 'fullname_moderator',
          },
        },
        {
          title: 'Block Reason',
          dataIndex: 'reason',
          key: 'reason',
          scopedSlots: {
            customRender: 'reason',
          },
        },
        {
          title: 'Created at',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: {
            customRender: 'created_at',
          },
        },
        {
          title: 'Sign',
          dataIndex: 'signature',
          key: 'signature',
          scopedSlots: {
            customRender: 'signature',
          },
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ].map(item => {
        if (item.key !== 'operation' && item.key !== 'role') {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => {
              let rr;
              switch (this.searchedColumn) {
                case 'email':
                  rr = record.user[this.searchedColumn];
                  break;
                case 'email_moderator':
                  rr = record.moderator[this.searchedColumn];
                  break;
                case 'fullname':
                  rr = record.user[this.searchedColumn];
                  break;
                case 'fullname_user':
                  rr = record.moderator[this.searchedColumn];
                  break;
                default:
                  rr = record[this.searchedColumn];
              }
              return rr && includes(slugData(rr), slugData(value));
            },
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  watch: {
    videos: {
      async handler(val) {
        this.videoData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    empty,
    getRoleInfo(text) {
      text = replace(text, '[', '');
      text = replace(text, ']', '');
      return text;
    },
    getFullName(record) {
      const { firstname, lastname } = record.user;
      return `${firstname || ''} ${lastname || ''}`.trimLeft();
    },
    getEmail(record) {
      return record.user.email;
    },
    getRole(record) {
      return record.user.role;
    },
    getModeratorFullName(record) {
      const { firstname, lastname } = record.admin || record.moderator;
      return `${firstname || ''} ${lastname || ''}`.trimLeft();
    },
    getModeratorEmail(record) {
      return (record.admin || record.moderator).email;
    },
    getCreatedAt(record) {
      const date = new Date(record.created_at || Date.now());
      return moment(date).format('MM/DD/YYYY');
    },
    async doInitData() {
      this.videos = await AdminService.videos.getShareStory();
    },
    handleReasonOk() {
      this.reason = '';
      this.reasonModalVisible = false;
    },
    showReasonInfo(text) {
      this.reason = text;
      this.reasonModalVisible = true;
    },
    async handleStatusChange(value, record) {
      this.isLoading = true;

      await AdminService.videos.update(record.id, {
        status: value,
        admin_id: store.state.user.user.userId,
      });
      this.isLoading = false;
    },
    handleReset(clearFilters) {
      clearFilters();
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.video.delete(record.id);

        this.$notification['success']({
          message: 'Delete successful.',
          description: `Story of ${record.user.firstname} ${record.user.lastname} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    getVideoUrl(record) {
      return Constants.APP_URL + `/${record.intro_type}/${record.slug}`;
    },
  },
};
</script>
<style lang="scss">
.select-value-review,
.select-value-notsure,
.select-option-review {
  color: #33cacc;
}
.select-value-approved,
.select-option-approved {
  color: #78beff;
}
.select-value-blocked,
.select-option-blocked {
  color: #eb685f;
}
</style>
